<template>
  <p>{{ val }}</p>
</template>

<script>
import { eventBus } from "@/main.ts";

export default {
  data() {
    return {
      val: "",
    };
  },
  props: {
    subTopic: {
      type: [String, Object],
    },
    clientMQTT: {
      type: Object,
    },
  },
  mounted() {
    this.clientMQTT.subscribe(this.subTopic);
    this.clientMQTT.on("message", (topic, data) => {
      if (this.subTopic == topic) {
        data = new TextDecoder("utf-8").decode(data);
        this.val = data;
      }
    });
  },
  beforeDestroy() {
    this.clientMQTT.unsubscribe(this.subTopic);
  },
};
</script>
